import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_USERS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import User from "./User";
import UserList from "./UserList";

export default function Users() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_USERS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/call-flow/users/new`));

  return <MasterDetail identifier="id" master={<UserList />} detail={<User />} />;
}
